// src/components/store/sections/testimonials/TestimonialV60CardsliderIndigoPulse.tsx
"use client";

import React from "react";
import DynamicTestimonialVariant from "./DynamicTestimonialVariant";

export default function TestimonialV60CardsliderIndigoPulse(props: any) {
  return (
    <DynamicTestimonialVariant
      variantNumber={60}
      archKey="card_slider"
      archLabel="Review Card Carousel"
      palName="IndigoPulse"
      grad="from-indigo-500 via-blue-600 to-violet-700"
      lightBg="bg-indigo-50"
      textCol="text-indigo-700"
      borderCol="border-indigo-200"
      btnCls="bg-indigo-600 hover:bg-indigo-700"
      hexCol="#6366f1"
      {...props}
    />
  );
}
